export default __webpack_public_path__ + "static/media/romanBlind.d6534c0c.jpg";